import { dateFormatters, pluralize } from '@frontend/duck-tape';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import { useCreateTaskContext } from '@frontend/web/hooks/context/useCreateTaskContext';

export const TaskPreview = () => {
  const { createTaskState } = useCreateTaskContext();
  const { description, interval, intervalCount, name, nextStartDate } = createTaskState.taskData;

  if (!name && !description) return null;

  return (
    <YStack className="bg-surfaceSecondary rounded-lg gap-y-sm p-md">
      <Text lineClamp={2}>{name || description}</Text>
      {createTaskState.isRecurrence && intervalCount && interval && nextStartDate ? (
        <XStack className="gap-x-sm">
          <XStack alignItems="center" className="gap-x-xs">
            <Icon color="tertiary" name="IconRepeat" />
            <Text color="secondary" type="p-sm">
              Every {intervalCount} {pluralize(interval, intervalCount)}
            </Text>
          </XStack>
          <XStack alignItems="center" className="gap-x-xs">
            <Icon color="tertiary" name="IconCalendarEvent" />
            <Text color="secondary" type="p-sm">
              Starting: {dateFormatters['MM/DD/YYYY'](nextStartDate)}
            </Text>
          </XStack>
        </XStack>
      ) : null}
    </YStack>
  );
};
